export const palette = {
  primary: '#7F56D9',
  primaryDark: '#6842C2',
  primaryDarker: '#5236A7',
  primaryLight: '#8D6AD9',
  primaryLighter: '#B29AE6',
  bgAlt: '#F1EDFB',
  bg: '#DDD6F6',
};
